var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider"},[(_vm.dividerText)?_c('span',{staticClass:"divider__text"},[_vm._v(_vm._s(_vm.dividerText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }